import { render, staticRenderFns } from "./NewGradeDialog.vue?vue&type=template&id=1accf714"
import script from "./NewGradeDialog.vue?vue&type=script&lang=js"
export * from "./NewGradeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports